import { Injectable, inject } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { APP_SETTINGS, AppSettings } from 'src/app.settings';
import { JobPostingResponse } from './openapi/model/jobPostingResponse';

@Injectable({
  providedIn: 'root',
})
export class MetaService {
  private readonly appSettings: AppSettings = inject(APP_SETTINGS);
  private meta: Meta = inject(Meta);

  removePostingMetaTags(tags: HTMLMetaElement[]): void {
    tags.forEach((tag) => this.meta.removeTagElement(tag));
  }

  addPostingMetaTags(posting: JobPostingResponse): HTMLMetaElement[] {
    const tags: HTMLMetaElement[] = [];
    this.addTagAndPush(tags, 'url', 'og:url', `${this.appSettings.BaseUrl}/jobs/${posting.jobPostingNumber}`);
    this.addTagAndPush(tags, 'type', 'og:type', 'website');
    this.addTagAndPush(tags, 'title', 'og:title', posting.jobTitle);
    this.addTagAndPush(tags, 'description', 'og:description', posting.jobTitle);
    this.addTagAndPush(
      tags,
      'image',
      'og:image',
      `${this.appSettings.BaseUrl}/assets/images/pcl_construction_craftlink.svg`
    );
    return tags;
  }

  private addTagAndPush(tags: HTMLMetaElement[], name: string, property: string, content: string): void {
    const tag = this.meta.addTag({ name: name, property: property, content: content });
    if (tag) {
      tags.push(tag);
    }
  }
}
